import { connect } from 'react-redux';
import utils from 'utils';
import { profileDataSelector } from 'selectors/profileSelectors';
import { MODAL } from 'constants';
import { openModal } from "actions/modal/openModal";
import ContactInformation from './ContactInformation';

const mapStateToProps = state => ({
  profileData: profileDataSelector(state, { phones: true, address_profile: true, oci_individual_status: true }),
});

const mapDispatchToProps = {
  openEditModal: () => openModal(MODAL.EDIT_PROFILE_CONTACT_INFORMATION_MODAL),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(utils.toJS(ContactInformation));
